export var ExtendedProviderType;
(function (ExtendedProviderType) {
    ExtendedProviderType["GoogleG"] = "genius-google";
    ExtendedProviderType["Twitter"] = "twitter";
    ExtendedProviderType["Discord"] = "discord";
    ExtendedProviderType["Google"] = "google";
    ExtendedProviderType["EthWallet"] = "ethwallet";
    ExtendedProviderType["WebAuthn"] = "webauthn";
    ExtendedProviderType["Apple"] = "apple";
    ExtendedProviderType["StytchOtp"] = "stytchOtp";
    ExtendedProviderType["StytchEmailFactorOtp"] = "stytchEmailFactorOtp";
    ExtendedProviderType["StytchSmsFactorOtp"] = "stytchSmsFactorOtp";
    ExtendedProviderType["StytchWhatsAppFactorOtp"] = "stytchWhatsAppFactorOtp";
    ExtendedProviderType["StytchTotpFactor"] = "stytchTotpFactor";
})(ExtendedProviderType || (ExtendedProviderType = {}));
